import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FaqModel } from 'src/app/shared/models/faq.models';
import { TerminosCondicionesModel } from 'src/app/shared/models/terminos-condiciones.model';


@Component({
	selector: 'app-menu-template4',
	templateUrl: './menu-template4.component.html',
	styleUrls: ['./menu-template4.component.scss'],
})
export class MenuTemplate4Component implements OnInit {
	@Input()
	faq: Array<FaqModel> = [];
	@Input()
	terminos: Array<TerminosCondicionesModel> = [];
	@Output()
	clickCollapse: EventEmitter<FaqModel>;
	constructor() {
		this.clickCollapse = new EventEmitter();
	}
	ngOnInit() {
	}
	onCollase(model: FaqModel) {
		this.clickCollapse.emit(model);
	}
}
